export function catchBlock<T>(fn: () => Promise<T>): Promise<[T, null] | [null, Error]>;
export function catchBlock<T>(fn: () => T): [T, null] | [null, Error];
export function catchBlock<T>(fn: () => T | Promise<T>): [T, null] | [null, Error] | Promise<[T, null] | [null, Error]> {
  try {
    const result = fn();
    if (result instanceof Promise) {
      // Handle async case
      return result
        .then((value): [T, null] => [value, null])
        .catch((error): [null, Error] => [null, error as Error]);
    }
    // Handle sync case
    return [result as T, null];
  } catch (error) {
    // Handle sync errors
    return [null, error as Error];
  }
}
